<template>
  <v-snackbar
    v-model="notification"
    :color="notificationColor"
    :timeout="notificationTimeout"
    :centered="notificationCentered"
    multi-line
  >
    {{ response }}
    <template v-slot:action="{ attrs }">
      <v-btn
        v-bind="attrs"
        @click="notification = false"
      >
        TAMAM
      </v-btn>
    </template>
    <!-- <v-btn
      dark
      @click="notification = !notification">
      Kapat
    </v-btn> -->
  </v-snackbar>
</template>

<script>
import { mapFields } from 'vuex-map-fields';

export default {
  name: 'Notification',
  computed: {
    ...mapFields([
      'notification',
      'notificationColor',
      'notificationBtnColor',
      'notificationTimeout',
      'response',
      'notificationCentered',
    ]),
  },
  watch: {
    notification(isOpen) {
      if (!isOpen) {
        setTimeout(() => {
          this.notificationTimeout = 3000;
          // this.response = '';
          this.notificationColor = '';
          this.notificationBtnColor = '';
          this.notificationCentered = false;
        }, 200);
      }
    },
  },
};
</script>
